import { render, staticRenderFns } from "./checkDoc.vue?vue&type=template&id=0bc478a8&scoped=true&"
import script from "./checkDoc.vue?vue&type=script&lang=js&"
export * from "./checkDoc.vue?vue&type=script&lang=js&"
import style0 from "./checkDoc.vue?vue&type=style&index=0&id=0bc478a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc478a8",
  null
  
)

export default component.exports